import { instance } from "./apiclient";

export function doorDash(
  orderValue,
  store,
  street,
  suburb,
  state,
  postcode,
  ScheduledTime
) {
  return instance.get(
    "delivery/" +
      store +
      "/Fee?OrderValue=" +
      orderValue +
      "&Street=" +
      street +
      "&Suburb=" +
      suburb +
      "&State=" +
      state +
      "&Postcode=" +
      postcode +
      "&ScheduledTime=" +
      ScheduledTime +
      ""
  );
}
